import { _ as _objectSpread2, b as _objectWithoutProperties, a as _toConsumableArray } from '../../../_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var _excluded = ["proposerDetails", "proposerDetailsMeta"];
var init_state = {
  businessType: '',
  customerFetchRequiredOnLoad: false,
  isQuoteSaved: false,
  quoteData: null,
  planData: null,
  prevPlanData: null,
  prevPlanName: '',
  prevTotalPremium: '',
  quoteNumber: '',
  quoteStatus: '',
  quoteCreationDate: '',
  proposalNumber: '',
  isProposalRenewed: false,
  proposalStatus: '',
  proposalPaymentType: '',
  isProposalApplicableForPayment: null,
  isPolicyIssued: false,
  planName: '',
  planCode: '',
  totalPremium: '',
  premiumLoading: false,
  planLoading: false,
  isProposalReadyForRenewal: true,
  isProposalRenewing: false,
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: '',
    intermediaryName: '',
    branchOfficeName: ''
  },
  proposerDetailsMeta: {
    crn: '',
    isNewCustomer: null,
    ifscCode: '',
    bankName: '',
    branchName: '',
    bankAcno: '',
    accountHolderName: '',
    micrCode: ''
  },
  proposerDetails: {
    id: '',
    customerType: '',
    title: '',
    gender: '',
    firstName: '',
    middleName: '',
    lastName: '',
    fullName: '',
    occupation: '',
    maritalStatus: '',
    nationality: '',
    proposerDOB: '',
    panNumber: '',
    idProofType: '',
    idProofNumber: '',
    permAddressLine1: '',
    permAddressLine2: '',
    permAddressLine3: '',
    permLandmark: '',
    permPincode: '',
    permCityTownVillage: '',
    permDistrict: '',
    permState: '',
    permCommAddressYN: true,
    commAddressLine1: '',
    commAddressLine2: '',
    commAddressLine3: '',
    commLandmark: '',
    commPincode: '',
    commCityTownVillage: '',
    commDistrict: '',
    commState: '',
    mobileNo: '',
    emailID: '',
    orgName: '',
    orgType: '',
    contactName: '',
    regNumber: '',
    tanNumber: '',
    gstNumber: '',
    phoneNo: '',
    altPhoneNo: '',
    altMobileNo: '',
    faxNo: '',
    employeeNumber: ''
  },
  sameNomineeForAllInsured: false,
  isHealthDeclarationSelected: '',
  initialHealthDeclarationSelected: '',
  insuredDetails: [],
  prevInsuranceDetails: [],
  nomineeDetails: [],
  medicalQuestionaire: [],
  underwritingAssignmentData: [],
  renewalMandateDetails: {},
  policyNumber: '',
  // SARN024
  Please_provide_existing_policy_number: '',
  // EARN024
  policy: {
    startDate: '',
    endDate: '',
    time: ''
  },
  issuedPolicyData: {
    policyNo: '',
    receiptID: [],
    referenceNumber: '',
    digiLink: '',
    displayMessage: '',
    additionalMessage: ''
  },
  premiumDetails: {
    termsAndConditions: false,
    paymentMethod: '',
    payerType: '',
    onlinePayment: {
      transactionId: '',
      isTransactionIdVerified: null
    },
    cdWallet: {
      cdAccountNo: '',
      cdAccountBalance: ''
    },
    cheque: [],
    demandDraft: []
  }
};
var viewRenewPolicyVar = makeVar(init_state);
var initViewRenewPolicyVar = function initViewRenewPolicyVar() {
  viewRenewPolicyVar(init_state);
};
var resetProposerDetails = function resetProposerDetails(data) {
  var initObj = {},
      initMetaObj = {};
  Object.keys(viewRenewPolicyVar().proposerDetails).forEach(function (v) {
    if (data !== null && data !== void 0 && data.proposerDetails[v]) {
      initObj[v] = data.proposerDetails[v];
    } else {
      if (v === 'permCommAddressYN') {
        initObj[v] = false;
      } else {
        initObj[v] = '';
      }
    }
  });
  Object.keys(viewRenewPolicyVar().proposerDetailsMeta).forEach(function (v) {
    if (data !== null && data !== void 0 && data.proposerDetailsMeta[v]) {
      initMetaObj[v] = data.proposerDetailsMeta[v];
    } else {
      initMetaObj[v] = '';
    }
  });
  viewRenewPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewPolicyVar()), {}, {
    proposerDetails: initObj,
    proposerDetailsMeta: initMetaObj
  }));
};
var updateHealthDeclaration = function updateHealthDeclaration(data) {
  return viewRenewPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewPolicyVar()), data));
};
var updatePlanWithPrevPlan = function updatePlanWithPrevPlan(isTotalPremiumRetainRequired) {
  var _viewRenewPolicyVar, _viewRenewPolicyVar2, _viewRenewPolicyVar3, _viewRenewPolicyVar4;

  viewRenewPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewPolicyVar()), {}, {
    planData: _objectSpread2(_objectSpread2({}, (_viewRenewPolicyVar = viewRenewPolicyVar()) === null || _viewRenewPolicyVar === void 0 ? void 0 : _viewRenewPolicyVar.planData), (_viewRenewPolicyVar2 = viewRenewPolicyVar()) === null || _viewRenewPolicyVar2 === void 0 ? void 0 : _viewRenewPolicyVar2.prevPlanData),
    planName: (_viewRenewPolicyVar3 = viewRenewPolicyVar()) === null || _viewRenewPolicyVar3 === void 0 ? void 0 : _viewRenewPolicyVar3.prevPlanName,
    totalPremium: isTotalPremiumRetainRequired ? (_viewRenewPolicyVar4 = viewRenewPolicyVar()) === null || _viewRenewPolicyVar4 === void 0 ? void 0 : _viewRenewPolicyVar4.prevTotalPremium : '',
    isProposalReadyForRenewal: true
  }));
};
var updatePrevPlanWithPlan = function updatePrevPlanWithPlan() {
  var _viewRenewPolicyVar5, _viewRenewPolicyVar6;

  viewRenewPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewPolicyVar()), {}, {
    prevPlanData: _objectSpread2(_objectSpread2({}, viewRenewPolicyVar().prevPlanData), viewRenewPolicyVar().planData),
    prevPlanName: (_viewRenewPolicyVar5 = viewRenewPolicyVar()) === null || _viewRenewPolicyVar5 === void 0 ? void 0 : _viewRenewPolicyVar5.planName,
    prevTotalPremium: (_viewRenewPolicyVar6 = viewRenewPolicyVar()) === null || _viewRenewPolicyVar6 === void 0 ? void 0 : _viewRenewPolicyVar6.totalPremium
  }));
};
var updateViewRenewPolicy = function updateViewRenewPolicy(data) {
  var proposerDetails = data.proposerDetails,
      proposerDetailsMeta = data.proposerDetailsMeta,
      rest = _objectWithoutProperties(data, _excluded);

  if (proposerDetails && proposerDetailsMeta) {
    viewRenewPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, viewRenewPolicyVar().proposerDetails), proposerDetails),
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, viewRenewPolicyVar().proposerDetailsMeta), proposerDetailsMeta)
    }, rest));
  } else if (proposerDetails && !proposerDetailsMeta) {
    viewRenewPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewPolicyVar()), {}, {
      proposerDetails: _objectSpread2(_objectSpread2({}, viewRenewPolicyVar().proposerDetails), proposerDetails)
    }, rest));
  } else if (!proposerDetails && proposerDetailsMeta) {
    viewRenewPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewPolicyVar()), {}, {
      proposerDetailsMeta: _objectSpread2(_objectSpread2({}, viewRenewPolicyVar().proposerDetailsMeta), proposerDetails)
    }, rest));
  } else {
    viewRenewPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewPolicyVar()), rest));
  }
};
var updatePlanPremium = function updatePlanPremium(planName, premium) {
  viewRenewPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewPolicyVar()), {}, {
    planData: _objectSpread2(_objectSpread2({}, viewRenewPolicyVar().planData), {}, {
      plans: [].concat(_toConsumableArray(viewRenewPolicyVar().planData.plans.filter(function (plan) {
        return plan.name.toLowerCase() !== planName.toLowerCase();
      })), [_objectSpread2(_objectSpread2({}, viewRenewPolicyVar().planData.plans.find(function (plan) {
        return plan.name.toLowerCase() === planName.toLowerCase();
      })), {}, {
        premium: premium
      })])
    }),
    prevPlanData: _objectSpread2(_objectSpread2({}, viewRenewPolicyVar().prevPlanData), {}, {
      plans: [].concat(_toConsumableArray(viewRenewPolicyVar().prevPlanData.plans.filter(function (plan) {
        return plan.name.toLowerCase() !== planName.toLowerCase();
      })), [_objectSpread2(_objectSpread2({}, viewRenewPolicyVar().prevPlanData.plans.find(function (plan) {
        return plan.name.toLowerCase() === planName.toLowerCase();
      })), {}, {
        premium: premium
      })])
    })
  }));
};
var updatePaymentMethod = function updatePaymentMethod(data) {
  return viewRenewPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewPolicyVar()), data));
};
var updateCheque = function updateCheque(data) {
  return viewRenewPolicyVar(_objectSpread2(_objectSpread2({}, viewRenewPolicyVar()), {}, {
    cheque: data
  }));
};

export { initViewRenewPolicyVar, resetProposerDetails, updateCheque, updateHealthDeclaration, updatePaymentMethod, updatePlanPremium, updatePlanWithPrevPlan, updatePrevPlanWithPlan, updateViewRenewPolicy, viewRenewPolicyVar };
